import axios from 'axios';

const getAllUsers = async (token) => {
  try {
    const response = await axios.get('/api/users', {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

const updateUserRole = async (userId, newRole, token) => {
  try {
    const response = await axios.put(`/api/users/${userId}/role`, { role: newRole }, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating user role:', error);
    throw error;
  }
};

const updateUserDiscount = async (userId, discount, token) => {
  try {
    const response = await axios.put(`/api/users/${userId}/discount`, { discount }, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating user discount:', error);
    throw error;
  }
};
const updateUserQuoteEnabled = async (userId, quoteEnabled, token) => {
  try {
    const response = await axios.patch(
      `/api/users/${userId}/quote-enabled`,
      { quoteEnabled },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating user quote permission:', error);
    throw error;
  }
};

const updateUserCompany = async (userId, companyName, token) => {
  try {
    const response = await axios.patch(
      `/api/users/${userId}/company`,
      { companyName },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating user company:', error);
    throw error;
  }
};

const updateUserProfile = async (userId, payload, token) => {
  try {
    const response = await axios.patch(
      `/api/users/${userId}/profile`,
      payload,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating user profile:', error);
    throw error;
  }
};

const updateCompanySharing = async (enabled, token) => {
  try {
    const response = await axios.patch(
      '/api/users/me/company-sharing',
      { enabled },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating company sharing preference:', error);
    throw error;
  }
};

const createFeedback = async (payload, token) => {
  try {
    const response = await axios.post('/api/users/feedback', payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error('Error creating feedback:', error);
    throw error;
  }
};

const getFeedbackList = async (token, status = '') => {
  try {
    const query = status ? `?status=${encodeURIComponent(status)}` : '';
    const response = await axios.get(`/api/users/feedback${query}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error('Error loading feedback list:', error);
    throw error;
  }
};

const updateFeedbackStatus = async (feedbackId, status, token) => {
  try {
    const response = await axios.patch(
      `/api/users/feedback/${feedbackId}/status`,
      { status },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating feedback status:', error);
    throw error;
  }
};


const sendPasswordResetEmail = async (email) => {
  try {
    const response = await axios.post('/api/password/request-password-reset', { email });
    return response.data;
  } catch (error) {
    console.error('Failed to send password reset email:', error);
    throw error;
  }

  /*try {
    const response = await axios.post('/api/users/reset-password', { email }, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error('Error sending password reset email:', error);
    throw error;
  }*/
};

const createUser = async (userData, token) => {
  try {
    const response = await axios.post('/api/users/create', userData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
};

const deleteUser = async (userId, token) => {
  await axios.delete(`/api/users/delete/${userId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const getOrdersByStatus = async (status, token) => {
  try {
    const response = await axios.get(`/api/orders?status=${status}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching orders by status:', error);
    throw error;
  }
};

const getOrderDetails = async (orderId, token) => {
  try {
    const response = await axios.get(`/api/orders/${orderId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching order details:', error);
    throw error;
  }
};

const updateOrderStatus = async (orderId, status, token) => {
  try {
    const response = await axios.put(`/api/orders/${orderId}/status`, { status }, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating order status:', error);
    throw error;
  }
};

const getAddressBook = async () => {
  const res = await axios.get("/api/users/addressbook");
  return res.data;
};

const addAddressBookContact = async (contact) => {
  const res = await axios.post("/api/users/addressbook", contact);
  return res.data;
};

const updateAddressBookContact = async (id, contact) => {
  const res = await axios.put(`/api/users/addressbook/${id}`, contact);
  return res.data;
};

const deleteAddressBookContact = async (id) => {
  const res = await axios.delete(`/api/users/addressbook/${id}`);
  return res.data;
};

const importAddressBook = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  const res = await axios.post("/api/users/addressbook/import", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};


const userService = {
  getAllUsers,
  updateUserRole,
  updateUserDiscount,
  updateUserQuoteEnabled,
  updateUserCompany,
  updateUserProfile,
  sendPasswordResetEmail,
  createUser,
  deleteUser,
  getOrdersByStatus,
  getOrderDetails,
  updateOrderStatus,
  getAddressBook,
  addAddressBookContact,
  updateAddressBookContact,
  deleteAddressBookContact,
  importAddressBook,
  updateCompanySharing,
  createFeedback,
  getFeedbackList,
  updateFeedbackStatus,
};

export default userService;

